import request from '@/utils/request'

/**
 * 获取绑定登录地址
 */
export function getBindLoginUrl(source) {
  return request({
    url: `/user/third/login/getBindLoginUrl/${source}`,
    method: 'get'
  })
}

/**
 * 获取第三方账号绑定信息
 */
export function listBind() {
  return request({
    url: '/user/third/login/bind/list',
    method: 'get'
  })
}

/**
 * 绑定第三方账号
 */
export function bindThirdUser(ticket) {
  return request({
    url: `/user/third/login/bind/${ticket}`,
    method: 'post'
  })
}

/**
 * 解绑第三方账号
 */
export function unbindThirdUser(source) {
  return request({
    url: `/user/third/login/unbind/${source}`,
    method: 'delete'
  })
}
